<!-- MOBILE SIDEBAR -->
<div class="fixed inset-0 z-[1000] lg:hidden" [class.is-open]="isMenuVisible"
  [attr.aria-hidden]="!isMenuVisible" [attr.inert]="isMenuVisible ? null : ''"
  role="dialog" aria-modal="true">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black backdrop-blur-sm transition-all duration-400 ease-out"
    [style.opacity]="isDrawerOpen ? '0.5' : '0'" [style.visibility]="isDrawerOpen ? 'visible' : 'hidden'"
    [style.backdrop-filter]="isDrawerOpen ? 'blur(4px)' : 'blur(0px)'" (click)="close.emit()"></div>

  <!-- Sidebar -->
  <div
    class="fixed top-0 left-0 h-full w-80 bg-white flex flex-col will-change-transform transition-all duration-400 ease-out"
    [class.translate-x-0]="isDrawerOpen" [class.-translate-x-full]="!isDrawerOpen" style="max-width: calc(100vw - 40px)"
    [attr.aria-hidden]="!isDrawerOpen">
    <!-- Header -->
    <div class="flex items-center justify-between p-4 bg-white transform transition-all duration-300 ease-out"
      [style.transform]="isDrawerOpen ? 'translateY(0)' : 'translateY(-20px)'"
      [style.opacity]="isDrawerOpen ? '1' : '0'" [style.transition-delay]="isDrawerOpen ? '200ms' : '0ms'">
      <h2 class="text-lg font-semibold">{{ 'Menu' | translate }}</h2>
      <button (click)="close.emit()"
        class="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200 active:scale-95 transform"
        [attr.aria-label]="'Zamknij menu' | translate">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Mobile Actions Section -->
    <div class="mobile-actions-section p-4 bg-gray-50 transform transition-all duration-300 ease-out"
      [style.transform]="isDrawerOpen ? 'translateY(0)' : 'translateY(-30px)'"
      [style.opacity]="isDrawerOpen ? '1' : '0'" [style.transition-delay]="isDrawerOpen ? '300ms' : '0ms'">
      <!-- Search Bar -->
      <div class="search-container mb-4">
        <div
          class="search-input relative flex items-center bg-white rounded-xl focus-within:border-orange-500 focus-within:ring-2 focus-within:ring-orange-100 transition-all duration-300 transform hover:scale-[1.02]">
          <!-- Search Icon -->
          <div class="flex items-center justify-center pl-4 pr-3">
            <svg class="w-5 h-5 text-gray-400 transition-colors duration-200" fill="none" stroke="currentColor"
              viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <!-- Input -->
          <input type="text" [placeholder]="'Szukaj produktów...' | translate" [attr.aria-label]="'Szukaj produktów' | translate"
            class="flex-1 py-3 pr-4 bg-transparent border-none text-gray-700 placeholder-gray-500 focus:outline-none text-base transition-all duration-200"
            [(ngModel)]="searchQuery" (input)="onSearchInput($event)" (keyup.enter)="performSearch()" autocomplete="off"
            autocorrect="off" autocapitalize="off" spellcheck="false" />
          <!-- Clear Button -->
          <button *ngIf="searchQuery" type="button" (click)="clearSearch()"
            class="flex items-center justify-center w-8 h-8 mr-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 active:scale-95 transform"
            [attr.aria-label]="'Wyczyść wyszukiwanie' | translate">
            <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Action Buttons Row -->
      <div class="action-buttons-row flex items-center gap-3 transform transition-all duration-300 ease-out"
        [style.transform]="isDrawerOpen ? 'translateY(0)' : 'translateY(-20px)'"
        [style.opacity]="isDrawerOpen ? '1' : '0'" [style.transition-delay]="isDrawerOpen ? '400ms' : '0ms'">
        <!-- Country/Currency Selector Button -->
        <button (click)="onCountryButtonClick($event)"
          class="flex-1 flex items-center justify-center gap-2 p-3 bg-white rounded-xl hover:bg-gray-50 active:bg-gray-100 transition-all duration-300 transform hover:scale-[1.02] active:scale-95"
          [ngClass]="{ 'country-active': isCountrySelectorOpen }" [attr.aria-label]="'Wybierz kraj i walutę' | translate"
          type="button">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 transition-transform duration-200">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12h19.5" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 2.25v19.5" />
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3s-4.5 4.03-4.5 9 2.015 9 4.5 9z" />
          </svg>
          <span class="text-sm font-medium transition-colors duration-200">{{ 'Kraj' | translate }}</span>
          <!-- Country indicator -->
          <span *ngIf="selectedCountry" class="text-lg ml-auto transition-transform duration-200 hover:scale-110">{{
            selectedCountry.flag }}</span>
        </button>

        <!-- Profile Button -->
        <button (click)="handleProfileButtonClick(); $event.stopPropagation()"
          class="flex-1 flex items-center justify-center gap-2 p-3 bg-white rounded-xl hover:bg-gray-50 active:bg-gray-100 transition-all duration-300 transform hover:scale-[1.02] active:scale-95"
          [ngClass]="{ 'profile-active': isAuthDropdownOpen && !isLoggedIn() }" [attr.aria-label]="'Przejdź do profilu' | translate"
          [attr.aria-expanded]="isAuthDropdownOpen && !isLoggedIn()">
          <!-- User Icon or Avatar -->
          <div *ngIf="!isLoggedIn()" class="w-5 h-5">
            <svg class="w-full h-full" [class.text-white]="isAuthDropdownOpen"
              [class.text-gray-700]="!isAuthDropdownOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>

          <!-- Logged In User Avatar -->
          <div *ngIf="isLoggedIn() && currentUser"
            class="w-5 h-5 bg-orange-600 rounded-full flex items-center justify-center text-white text-xs font-semibold">
            {{ getInitials(currentUser) }}
          </div>

          <span class="text-sm font-medium">{{ (isLoggedIn() ? 'Profil' : 'Zaloguj się') | translate }}</span>
        </button>
      </div>
    </div>

    <!-- Mobile Auth Dropdown Overlay -->
    <div *ngIf="isAuthDropdownOpen && !isLoggedIn()" class="absolute top-0 left-0 right-0 bg-white z-50" [@slideDown]
      style="box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);">
      <!-- Header with Back Button -->
      <div class="flex items-center justify-between p-4">
        <button (click)="toggleAuthDropdown()"
          class="flex items-center gap-2 text-gray-600 hover:text-orange-600 transition-colors duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          <span class="text-sm font-medium">{{ 'Wróć' | translate }}</span>
        </button>
        <h2 class="text-lg font-semibold text-gray-900">{{ 'Witamy' | translate }}</h2>
        <div class="w-16"></div> <!-- Spacer for centering -->
      </div>

      <!-- Welcome Content -->
      <div class="p-6">
        <div class="text-center mb-6">
          <p class="text-gray-600">{{ 'Wybierz sposób kontynuowania' | translate }}</p>
        </div>

        <!-- Sign In Option -->
        <div class="mb-4 p-4 bg-orange-50 rounded-xl">
          <div class="flex items-start gap-3">
            <div class="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1">
                </path>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="font-semibold text-gray-900 mb-1">{{ 'Zaloguj się' | translate }}</h3>
              <p class="text-sm text-gray-600 mb-3">{{ 'Uzyskaj dostęp do konta i zarządzaj swoimi zamówieniami.' | translate }}</p>
              <button (click)="goToSignIn(); close.emit()"
                class="flex items-center gap-2 text-orange-600 font-medium hover:text-orange-700 transition-colors duration-200">
                <span>{{ 'Przejdź do logowania' | translate }}</span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Create Account Option -->
        <div class="p-4 bg-gray-50 rounded-xl">
          <div class="flex items-start gap-3">
            <div class="w-12 h-12 bg-gray-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="font-semibold text-gray-900 mb-1">{{ 'Utwórz konto' | translate }}</h3>
              <p class="text-sm text-gray-600 mb-3">{{ 'Załóż konto, aby sprawniej składać zamówienia i zarządzać danymi.' | translate }}</p>
              <button (click)="goToSignUp(); close.emit()"
                class="flex items-center gap-2 text-gray-600 font-medium hover:text-gray-700 transition-colors duration-200">
                <span>{{ 'Załóż konto' | translate }}</span>
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Security Features -->
        <div class="flex items-center justify-center gap-6 mt-6 pt-4">
          <div class="flex items-center gap-2 text-sm text-gray-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
              </path>
            </svg>
            <span>{{ 'Bezpieczne i szyfrowane' | translate }}</span>
          </div>
          <div class="flex items-center gap-2 text-sm text-gray-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z">
              </path>
            </svg>
            <span>{{ 'Szybko i wygodnie' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Content -->
    <div class="flex-1 flex flex-col min-h-0 animate-fade-in ease-out"
      [style.transform]="isDrawerOpen ? 'translateY(0)' : 'translateY(-40px)'"
      [style.opacity]="isDrawerOpen ? '1' : '0'" [style.transition-delay]="isDrawerOpen ? '500ms' : '0ms'">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="flex items-center justify-center p-8 transform transition-all duration-300"
        [style.opacity]="isDrawerOpen ? '1' : '0'">
        <app-loading-spinner [show]="true" [message]="'Ładowanie menu...' | translate" spinnerClass="small">
        </app-loading-spinner>
      </div>

      <!-- Desktop Navigation Tabs (Hidden on mobile) -->
      <div *ngIf="!isLoading" class="hidden md:block">
        <nav class="flex overflow-x-auto">
          <button *ngFor="let tab of titles; trackBy: trackByTitle; let i = index" (click)="onCategoryClick(tab)"
            class="flex-shrink-0 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors duration-300"
            [class.border-orange-500]="tab?.id === hoveredCategory?.id"
            [class.text-orange-600]="tab?.id === hoveredCategory?.id"
            [class.border-transparent]="tab?.id !== hoveredCategory?.id"
            [class.text-gray-500]="tab?.id !== hoveredCategory?.id && tab?.name !== 'SALE' && tab?.name !== 'NEW'"
            [class.text-red-600]="tab?.id !== hoveredCategory?.id && tab?.name === 'SALE'"
            [class.text-green-600]="tab?.id !== hoveredCategory?.id && tab?.name === 'NEW'"
            [class.font-bold]="tab?.name === 'SALE' || tab?.name === 'NEW'">
            {{ tab.name === 'SALE'
              ? ('mega_menu.promotions' | translate:'Promocje')
              : tab.name === 'NEW'
                ? ('mega_menu.new_arrivals' | translate:'Nowości')
                : (getMenuTabLabel(tab.name) | translate) }}
          </button>
        </nav>

        <!-- Sub-Navigation Tabs (Desktop) -->
        <nav *ngIf="hoveredCategory?.children && hoveredCategory.children.length > 0"
          class="flex overflow-x-auto px-4 py-2 bg-gray-50">
          <button *ngFor="let subTab of hoveredCategory.children; trackBy: trackByChild" (click)="onSubTabClick(subTab)"
            class="flex-shrink-0 px-3 py-2 text-xs font-medium whitespace-nowrap rounded-md mr-2"
            [class.bg-orange-100]="subTab?.id === selectedSubTab?.id"
            [class.text-orange-700]="subTab?.id === selectedSubTab?.id"
            [class.bg-white]="subTab?.id !== selectedSubTab?.id"
            [class.text-gray-600]="subTab?.id !== selectedSubTab?.id" [class.border]="subTab?.id !== selectedSubTab?.id"
            [class.border-gray-200]="subTab?.id !== selectedSubTab?.id">
            {{ subTab.name | translate }}
          </button>
        </nav>
      </div>

      <!-- Mobile: Multi-Level Navigation -->
      <div *ngIf="!isLoading" class="md:hidden flex-1 overflow-y-auto">
        <!-- Level 1: Main Categories (when nothing is selected) -->
        <div *ngIf="!hoveredCategory" class="space-y-2 p-3">
          <div *ngFor="let tab of titles; trackBy: trackByTitle; let i = index"
            class="overflow-hidden transform transition-all duration-300 ease-out hover:scale-[1.02]"
            [style.animation-delay]="(i * 50) + 'ms'" [@expandCollapse]>
            <button (click)="toggleMobileCategory(tab)"
              class="w-full flex items-center justify-between p-4 bg-white hover:bg-gray-50 transition-all duration-200 active:scale-95 transform">
              <div class="flex items-center gap-3">
                <div class="w-2 h-2 rounded-full transition-all duration-200" [class.bg-red-500]="tab?.name === 'SALE'"
                  [class.bg-green-500]="tab?.name === 'NEW'"
                  [class.bg-orange-500]="tab?.name !== 'SALE' && tab?.name !== 'NEW'">
                </div>
                <span class="font-medium text-left transition-colors duration-200 text-sm sm:text-base leading-tight"
                  [class.text-red-600]="tab?.name === 'SALE'" [class.text-green-600]="tab?.name === 'NEW'"
                  [class.text-gray-900]="tab?.name !== 'SALE' && tab?.name !== 'NEW'">
                  {{ getMenuTabLabel(tab.name) | translate }}
                </span>
              </div>
              <svg class="w-5 h-5 text-gray-400 transition-transform duration-200 hover:scale-110" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Level 2: Sub-tabs (when main category is selected but no sub-tab) -->
        <div
          *ngIf="hoveredCategory && !selectedSubTab && hoveredCategory.children && hoveredCategory.children.length > 0"
          class="p-3">
          <!-- Back button -->
          <button (click)="goBackToMainCategories()"
            class="flex items-center gap-2 mb-4 p-2 text-gray-600 hover:text-orange-600 transition-colors duration-200">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            <span class="text-xs sm:text-sm font-medium">{{ 'mega_menu.back' | translate:'Wróć' }}</span>
          </button>

          <!-- Current category header -->
          <div class="mb-4 p-3 bg-orange-50 rounded-lg border border-orange-200">
            <h3 class="font-semibold text-orange-900">{{ hoveredCategory.name | translate }}</h3>
            <p class="text-sm text-orange-700 mt-1">
              {{ 'mega_menu.choose_section' | translate:'Wybierz sekcję, aby przeglądać kategorie.' }}
            </p>
          </div>

          <!-- Sub-tabs as cards -->
          <div class="space-y-2">
            <div *ngFor="let subTab of hoveredCategory.children; trackBy: trackByChild" class="overflow-hidden">
              <button (click)="onSubTabClick(subTab)"
                class="w-full flex items-center justify-between p-4 bg-white hover:bg-gray-50 transition-colors duration-200">
                <div class="flex items-center gap-3">
                  <div class="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span class="font-medium text-gray-900 text-sm sm:text-base leading-tight break-words">{{ subTab.name | translate
                    }}</span>
                </div>
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Level 3: Categories with subcategories (when sub-tab is selected OR main category has no sub-tabs) -->
        <div
          *ngIf="hoveredCategory && (selectedSubTab || !hoveredCategory.children || hoveredCategory.children.length === 0)"
          class="p-3">
          <!-- Back button -->
          <button (click)="goBackFromCategories()"
            class="flex items-center gap-2 mb-4 p-2 text-gray-600 hover:text-orange-600 transition-colors duration-200">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            <span class="text-sm font-medium">
              {{ 'mega_menu.back' | translate:'Wróć' }}
            </span>
          </button>

          <!-- Current section header -->
          <div class="mb-4 p-3 bg-orange-50 rounded-lg border border-orange-200">
            <h3 class="font-semibold text-orange-900 text-sm sm:text-base leading-tight break-words">
              {{ menuSelection === 'NEW'
                ? ('mega_menu.new_arrivals' | translate:'Nowości')
                : (selectedSubTab ? selectedSubTab.name : hoveredCategory.name) }}
            </h3>
            <p class="text-xs sm:text-sm text-orange-700 mt-1">
              {{ menuSelection === 'NEW'
                ? ('mega_menu.check_latest_products' | translate:'Sprawdź najnowsze produkty')
                : ('mega_menu.browse_categories' | translate:'Przeglądaj kategorie i podkategorie') }}
            </p>
          </div>

          <div *ngIf="menuSelection === 'NEW'" class="space-y-3">
            <p *ngIf="isLoadingNewProducts" class="p-4 text-center text-sm text-gray-500" role="status">
              {{ 'mega_menu.loading_new' | translate:'Ładowanie nowości…' }}
            </p>
            <p *ngIf="!isLoadingNewProducts && newProductsError" class="p-4 text-center text-sm text-red-700" role="alert">
              {{ 'mega_menu.new_error' | translate:'Nie udało się załadować nowości. Spróbuj ponownie później.' }}
            </p>
            <p *ngIf="!isLoadingNewProducts && !newProductsError && newProducts.length === 0"
              class="p-4 text-center text-sm text-gray-500">
              {{ 'mega_menu.no_new' | translate:'Obecnie brak nowych produktów.' }}
            </p>

            <div *ngIf="newProducts.length > 0" class="grid grid-cols-2 gap-3">
              <a *ngFor="let product of newProducts; trackBy: trackByProduct"
                [routerLink]="['/products', product.id]" (click)="onLinkClick()"
                class="relative flex min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                <span *ngIf="isNewProduct(product)"
                  class="absolute left-2 top-2 z-10 rounded-full bg-orange-500 px-2 py-1 text-[10px] font-bold text-white">
                  {{ 'mega_menu.new_badge' | translate:'NOWOŚĆ' }}
                </span>
                <span *ngIf="getNewProductAvailability(product) as availability"
                  class="absolute right-2 top-2 z-10 rounded-full bg-white/95 px-2 py-1 text-[10px] font-semibold text-gray-700 shadow-sm">
                  {{ availability.label | translate }}
                </span>
                <img [src]="getNewProductImage(product)"
                  [alt]="(product.label || product.name || 'Produkt') | translate"
                  class="h-32 w-full bg-white p-2 object-contain mix-blend-multiply" loading="lazy"
                  (error)="onNewProductImageError($event)" />
                <span class="flex flex-1 flex-col gap-1 p-2">
                  <span *ngIf="getNewProductCategory(product) as category"
                    class="truncate text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                    {{ category | translate }}
                  </span>
                  <span class="line-clamp-2 text-sm font-semibold leading-snug text-gray-900">
                    {{ (product.label || product.name || 'Produkt') | translate }}
                  </span>
                  <span *ngIf="getNewProductReference(product) as reference"
                    class="truncate text-[10px] text-gray-500">{{ 'Nr kat.:' | translate }} {{ reference }}</span>
                  <span *ngIf="product.producer?.label || product.producer?.name || product.producer"
                    class="truncate text-[10px] text-gray-500">
                    {{ (product.producer?.label || product.producer?.name || product.producer) | translate }}
                  </span>
                  <span class="mt-auto flex items-center gap-2 pt-1">
                    <ng-container *ngIf="getNewProductPricing(product) as pricing">
                      <span *ngIf="pricing.price !== null" class="text-sm font-bold text-orange-600">
                        {{ pricing.price | appendCurrency }}
                      </span>
                      <span *ngIf="pricing.originalPrice" class="text-xs text-gray-400 line-through">
                        {{ pricing.originalPrice | appendCurrency }}
                      </span>
                      <span *ngIf="pricing.price === null" class="text-xs font-semibold text-orange-600">
                        {{ 'mega_menu.price_on_request' | translate:'Cena na zapytanie' }}
                      </span>
                    </ng-container>
                  </span>
                  <span class="text-[10px] text-gray-400">{{ 'mega_menu.net' | translate:'netto' }}</span>
                </span>
              </a>
            </div>

            <a routerLink="/products" [queryParams]="{ isNew: 'true' }" (click)="onLinkClick()"
              class="flex min-h-11 items-center justify-center rounded-lg border border-orange-200 bg-orange-50 px-4 text-sm font-semibold text-orange-700">
              {{ 'mega_menu.view_new_products' | translate:'Zobacz wszystkie nowości' }}
              <span class="ml-2" aria-hidden="true">→</span>
            </a>
          </div>

          <!-- Categories with dropdown functionality -->
          <div *ngIf="menuSelection !== 'NEW'" class="space-y-3">
            <div *ngFor="let category of filteredCategories; trackBy: trackByCategory"
              class="border border-gray-200 rounded-lg shadow-sm overflow-hidden">
              <!-- Parent Category Display for Special Tabs -->
              <div *ngIf="category.parentLabel" class="px-3 py-2 bg-gray-100 border-b border-gray-200">
                <span class="text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ category.parentLabel | translate }}
                </span>
              </div>

              <!-- Category Header -->
              <div class="flex items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                [class.bg-gray-50]="isExpanded(category.id)" (click)="handleCategoryClick(category)">
                <div class="flex items-center justify-between flex-1">
                  <span class="font-semibold text-gray-900 text-sm sm:text-base leading-tight break-words pr-2">{{
                    category.label | translate }}</span>

                  <div class="flex items-center gap-2">
                    <!-- Product count badge -->
                    <span class="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full font-medium"
                      *ngIf="getTotalProductCount(category) > 0">
                      {{ getTotalProductCount(category) }}
                    </span>

                    <!-- Dropdown arrow for categories with children -->
                    <svg *ngIf="category.children && category.children.length > 0"
                      class="w-5 h-5 text-gray-400 transition-transform duration-200"
                      [class.rotate-180]="isExpanded(category.id)" fill="none" stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Subcategories dropdown -->
              <div *ngIf="category.children && category.children.length > 0 && isExpanded(category.id)"
                class="border-t border-gray-200 bg-gray-50/50 animate-fade-in">
                <div class="p-2 space-y-1">
                  <a *ngFor="let subcategory of category.children; trackBy: trackByChild"
                    class="flex items-center p-3 text-sm text-gray-600 hover:text-orange-600 hover:bg-white rounded-lg transition-all duration-200 border border-transparent hover:border-orange-200 cursor-pointer"
                    (click)="onSubcategoryClick(subcategory); close.emit()">
                    <div class="w-2 h-2 bg-orange-400 rounded-full mr-3 flex-shrink-0"></div>
                    <span class="text-xs sm:text-sm leading-relaxed break-words">{{ subcategory.label | translate }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Language Switcher -->
    <div class="border-t p-4">
      <h3 class="text-xs sm:text-sm font-medium text-gray-900 mb-3 text-center break-words">
        {{ 'mega_menu.language_selection' | translate:'Język' }}
      </h3>
      <div class="flex justify-center space-x-2">
        <button (click)="changeLanguage('en')"
          class="px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 transform"
          [class.bg-orange-500]="currentLanguage === 'en'" [class.text-white]="currentLanguage === 'en'"
          [class.shadow-lg]="currentLanguage === 'en'" [class.scale-105]="currentLanguage === 'en'"
          [class.text-gray-700]="currentLanguage !== 'en'" [class.hover:bg-gray-100]="currentLanguage !== 'en'"
          [class.hover:scale-105]="currentLanguage !== 'en'" [disabled]="isAnimating">
          EN
        </button>
        <button (click)="changeLanguage('fr')"
          class="px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 transform"
          [class.bg-orange-500]="currentLanguage === 'fr'" [class.text-white]="currentLanguage === 'fr'"
          [class.shadow-lg]="currentLanguage === 'fr'" [class.scale-105]="currentLanguage === 'fr'"
          [class.text-gray-700]="currentLanguage !== 'fr'" [class.hover:bg-gray-100]="currentLanguage !== 'fr'"
          [class.hover:scale-105]="currentLanguage !== 'fr'" [disabled]="isAnimating">
          FR
        </button>
        <button (click)="changeLanguage('pl')"
          class="px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 transform"
          [class.bg-orange-500]="currentLanguage === 'pl'" [class.text-white]="currentLanguage === 'pl'"
          [class.shadow-lg]="currentLanguage === 'pl'" [class.scale-105]="currentLanguage === 'pl'"
          [class.text-gray-700]="currentLanguage !== 'pl'" [class.hover:bg-gray-100]="currentLanguage !== 'pl'"
          [class.hover:scale-105]="currentLanguage !== 'pl'" [disabled]="isAnimating">
          PL
        </button>
      </div>
    </div>
  </div>
</div>

<!-- DESKTOP MEGA MENU -->
<div class="mega-menu-container" [class.is-open]="isMenuVisible"
  [class.is-promo-view]="isPromoMenuSelection" [class.is-new-arrivals]="menuSelection === 'NEW'"
  [attr.aria-hidden]="!isMenuVisible"
  [attr.inert]="isMenuVisible ? null : ''"
  role="dialog" aria-modal="true" [attr.aria-label]="'mega_menu.title' | translate:'Kategorie produktów'"
  (click)="close.emit()">
  <div class="mega-menu-content" (click)="$event.stopPropagation()">
    <div class="desktop-menu-topbar">
      <span>{{ 'mega_menu.title' | translate:'Kategorie produktów' }}</span>
      <button type="button" class="desktop-menu-close"
        [attr.aria-label]="'mega_menu.close' | translate:'Zamknij'"
        (click)="close.emit()">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" />
        </svg>
        <span>{{ 'mega_menu.close' | translate:'Zamknij' }}</span>
      </button>
    </div>
    <div class="flex flex-col justify-between h-full">
      <!-- Desktop Mega Menu -->
      <div class="h-full flex flex-col">
        <!-- Category Navigation -->
        <nav class="category-nav desktop-parent-tabs"
          [attr.aria-label]="'mega_menu.category_navigation' | translate:'Kategorie produktów'">
          <button *ngFor="let item of desktopParentTabs; trackBy: trackByTitle" type="button" (click)="onCategoryClick(item)"
            class="category-item" [ngClass]="{
              'active': item?.id === hoveredCategory?.id,
              'sales-tab': item?.name === 'SALE',
              'new-tab': item?.name === 'NEW'
            }" [attr.aria-pressed]="item?.id === hoveredCategory?.id">
              <span class="desktop-tab-image-placeholder" aria-hidden="true">
                <img *ngIf="item.imageUrl" [src]="item.imageUrl" alt="" loading="lazy" decoding="async"
                  (error)="onNavigationTabImageError($event)" />
              </span>
              <span class="category-label" [class.text-red-600]="item?.name === 'SALE'"
                [class.text-orange-600]="item?.name === 'NEW'"
                [class.font-bold]="item?.name === 'SALE' || item?.name === 'NEW'">
              {{ item.name | translate }}
            </span>
          </button>
        </nav>

        <!-- Sub-Tab Navigation (when main tab has children) -->
        <nav class="sub-tab-nav desktop-sub-tabs"
          [attr.aria-label]="'mega_menu.section_navigation' | translate:'Sekcje produktów'"
          *ngIf="hoveredCategory?.children && hoveredCategory.children.length > 0">
          <button *ngFor="let subTab of hoveredCategory.children; trackBy: trackByChild" type="button"
            (click)="onSubTabClick(subTab)" class="sub-tab-item"
            [ngClass]="{ 'active': subTab?.id === selectedSubTab?.id }"
            [attr.aria-pressed]="subTab?.id === selectedSubTab?.id">
            <span class="sub-tab-label">{{ subTab.name | translate }}</span>
          </button>
        </nav>

        <!-- Main content area with responsive layout -->
        <div #desktopContentPane class="flex flex-col xl:flex-row gap-8 xl:gap-12 items-start mt-4">
          <!-- Left side: Categories content -->
            <div class="flex-1 min-w-0">
              <!-- ***** CATEGORIES ***** -->
              <div *ngIf="hoveredCategory" class="content-section" [ngClass]="{ 'active': hoveredCategory }">
                <header class="desktop-selected-parent-header" [class.is-promo-header]="isPromoMenuSelection">
                  <div class="desktop-selected-parent-identity">
                    <span class="desktop-header-image-placeholder" aria-hidden="true">
                    <svg *ngIf="hoveredCategory.id === -1" class="promo-header-icon sale-icon"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                      <circle cx="7.5" cy="7.5" r="2" stroke-width="1.8" />
                      <circle cx="16.5" cy="16.5" r="2" stroke-width="1.8" />
                      <path stroke-linecap="round" stroke-width="1.8" d="m18 5-12 14" />
                    </svg>
                    <svg *ngIf="hoveredCategory.id === -2" class="promo-header-icon new-icon"
                      viewBox="0 0 48 48" fill="none" aria-hidden="true">
                      <path d="m24 5 4.8 13.2L42 23l-13.2 4.8L24 41l-4.8-13.2L6 23l13.2-4.8L24 5Z"
                        fill="currentColor" opacity=".16" />
                      <path d="m24 8 4.1 11.1L39 23l-10.9 3.9L24 38l-4.1-11.1L9 23l10.9-3.9L24 8Z"
                        stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" />
                      <path d="m38 5 1.4 3.6L43 10l-3.6 1.4L38 15l-1.4-3.6L33 10l3.6-1.4L38 5Z"
                        fill="currentColor" />
                    </svg>
                    <img *ngIf="!isPromoMenuSelection && hoveredCategory.imageUrl" [src]="hoveredCategory.imageUrl" alt="" loading="lazy"
                      decoding="async" (error)="onNavigationTabImageError($event)" />
                    </span>
                    <div class="min-w-0">
                      <h2>{{ menuSelection === 'NEW'
                        ? ('mega_menu.new_arrivals' | translate:'Nowości')
                        : menuSelection === 'SALE'
                          ? ('mega_menu.promotions' | translate:'Promocje')
                          : (getMenuTabLabel(hoveredCategory.name) | translate) }}</h2>
                      <p *ngIf="menuSelection !== 'NEW' && hoveredCategory.description">{{ hoveredCategory.description | translate }}</p>
                    </div>
                  </div>
                  <div class="desktop-menu-header-actions">
                    <a *ngIf="desktopCategoryFilter && !isPromoMenuSelection" [routerLink]="['/products']"
                      [queryParams]="{ category: desktopCategoryFilter }" (click)="onLinkClick()"
                      class="desktop-view-category-link">
                      {{ 'mega_menu.view_category' | translate:'Zobacz całą kategorię' }}
                      <span aria-hidden="true">→</span>
                    </a>
                    <a *ngIf="isPromoMenuSelection" [routerLink]="['/products']"
                      [queryParams]="menuSelection === 'SALE' ? { discount: 'true' } : { isNew: 'true' }"
                      (click)="onLinkClick()" class="desktop-view-category-link">
                      {{ menuSelection === 'SALE'
                        ? ('mega_menu.view_sale_products' | translate:'Zobacz wszystkie produkty w promocji')
                        : ('mega_menu.view_new_products' | translate:'Zobacz wszystkie nowości') }}
                      <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </header>

                <section *ngIf="menuSelection === 'NEW'" class="desktop-new-products"
                  [attr.aria-label]="'mega_menu.new_arrivals' | translate:'Nowości'">
                  <div *ngIf="isLoadingNewProducts" class="desktop-new-products-message" role="status">
                    {{ 'mega_menu.loading_new' | translate:'Ładowanie nowości…' }}
                  </div>
                  <div *ngIf="!isLoadingNewProducts && newProductsError" class="desktop-new-products-message" role="alert">
                    {{ 'mega_menu.new_error' | translate:'Nie udało się załadować nowości. Spróbuj ponownie później.' }}
                  </div>
                  <div *ngIf="!isLoadingNewProducts && !newProductsError && newProducts.length === 0"
                    class="desktop-new-products-message">
                    {{ 'mega_menu.no_new' | translate:'Obecnie brak nowych produktów.' }}
                  </div>

                  <div *ngIf="newProductCards.length > 0" class="desktop-new-products-carousel"
                    [class.can-scroll-left]="newProductsCanScrollLeft"
                    [class.can-scroll-right]="newProductsCanScrollRight">
                    <button *ngIf="newProductCards.length > 4" type="button" class="desktop-new-products-arrow"
                      [disabled]="!newProductsCanScrollLeft"
                      [attr.aria-label]="'mega_menu.scroll_previous_new' | translate:'Przewiń do wcześniejszych nowości'"
                      (click)="scrollNewProducts(-1)">
                      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
                        <path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                    <div class="desktop-new-products-content">
                      <div #newProductsTrack class="desktop-new-products-track"
                        (scroll)="onNewProductsScroll()"
                        (scrollend)="updateNewProductsScrollState()">
                        <article *ngFor="let card of newProductCards; trackBy: trackByNewProductCard"
                          class="desktop-new-product-card">
                          <a [routerLink]="['/products', card.product.id]" (click)="onLinkClick()"
                            class="desktop-new-product-link">
                            <span class="desktop-new-product-image-wrap">
                              <span *ngIf="card.badge === 'NEW'" class="desktop-new-product-badge">
                                {{ 'mega_menu.new_badge' | translate:'NOWOŚĆ' }}
                              </span>
                              <img [src]="card.image"
                                [alt]="(card.product.label || card.product.name || 'Produkt') | translate"
                                loading="lazy" decoding="async" (error)="onNewProductImageError($event)" />
                            </span>
                            <span class="desktop-new-product-details">
                              <span *ngIf="card.category"
                                class="desktop-new-product-category">
                                {{ card.category | translate }}
                              </span>
                              <span class="desktop-new-product-name">
                                {{ (card.product.label || card.product.name || 'Produkt') | translate }}
                              </span>
                              <span class="desktop-new-product-meta">
                                <span *ngIf="card.reference">{{ 'Nr kat.:' | translate }} {{ card.reference }}</span>
                                <span *ngIf="card.producer">{{ card.producer | translate }}</span>
                                <span *ngIf="card.availability">{{ card.availability.label | translate }}</span>
                              </span>
                              <span class="desktop-new-product-price-row">
                                <span *ngIf="card.pricing.price !== null" class="desktop-new-product-price">
                                  {{ card.pricing.price | appendCurrency }}
                                </span>
                                <span *ngIf="card.pricing.discount > 0" class="desktop-new-product-discount">
                                  -{{ card.pricing.discount }}%
                                </span>
                                <span *ngIf="card.pricing.originalPrice" class="desktop-new-product-original-price">
                                  {{ card.pricing.originalPrice | appendCurrency }}
                                </span>
                                <span *ngIf="card.pricing.price === null" class="desktop-new-product-quote">
                                  {{ 'mega_menu.price_on_request' | translate:'Cena na zapytanie' }}
                                </span>
                              </span>
                              <span class="desktop-new-product-vat">
                                {{ 'mega_menu.net_without_vat' | translate:'Cena netto (bez VAT)' }}
                              </span>
                            </span>
                          </a>
                          <div class="desktop-new-product-actions">
                            <button *ngIf="card.pricing.price !== null; else requestNewProductQuote"
                              type="button" class="desktop-new-product-action desktop-new-product-add"
                              (click)="openNewProductPreview(card.product, $event)">
                              {{ 'Szybki podgląd' | translate }}
                              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.8"
                                  stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </button>
                            <ng-template #requestNewProductQuote>
                              <button type="button" class="desktop-new-product-action desktop-new-product-request"
                                (click)="requestNewProductQuoteFor(card.product, $event)">
                                {{ 'mega_menu.ask_for_price' | translate:'Zapytaj o cenę' }}
                              </button>
                            </ng-template>
                          </div>
                        </article>
                      </div>
                      <div *ngIf="newProductsPageCount > 1" class="desktop-new-products-pagination"
                        role="group"
                        [attr.aria-label]="'mega_menu.page_of_new_products' | translate:'Strony z nowościami'">
                        <button *ngFor="let page of newProductsPages; let i = index" type="button"
                          class="desktop-new-products-page"
                          [class.is-active]="i === newProductsActivePage"
                          [attr.aria-label]="('mega_menu.show_new_products_page' | translate:'Pokaż stronę z nowościami') + ' ' + (i + 1)"
                          [attr.aria-current]="i === newProductsActivePage ? 'true' : null"
                          (click)="goToNewProductsPage(i)"></button>
                      </div>
                    </div>
                    <button *ngIf="newProductCards.length > 4" type="button" class="desktop-new-products-arrow"
                      [disabled]="!newProductsCanScrollRight"
                      [attr.aria-label]="'mega_menu.scroll_next_new' | translate:'Przewiń do kolejnych nowości'"
                      (click)="scrollNewProducts(1)">
                      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
                        <path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </button>
                  </div>
                </section>

                <div *ngIf="menuSelection !== 'NEW'" class="desktop-tab-sections">
                  <ng-container *ngFor="let section of desktopSections; trackBy: trackByDesktopSection">
                    <section class="desktop-tab-section">
                      <header *ngIf="!isPromoMenuSelection" class="desktop-tab-section-header">
                        <span class="desktop-tab-section-number">{{ formatSectionNumber(section.index) }}</span>
                        <div class="desktop-tab-section-heading">
                          <a [routerLink]="['/products']"
                            [queryParams]="getDesktopCategoryQueryParams(section.tab.id)"
                            (click)="onLinkClick()" class="desktop-tab-section-title">
                            {{ section.tab.name | translate }}
                          </a>
                        </div>
                      </header>

                      <div *ngIf="section.categories.length > 0" class="desktop-mapped-categories">
                        <article class="desktop-mapped-category"
                          *ngFor="let category of section.categories; trackBy: trackByCategory">
                          <a *ngIf="isPromoMenuSelection" [routerLink]="['/products']"
                            [queryParams]="getDesktopCategoryQueryParams(category.id)"
                            (click)="onLinkClick()" class="desktop-mapped-category-title">
                            {{ (category.label || category.name) | translate }}
                            <span *ngIf="(desktopCategoryCounts.get(category.id) ?? 0) > 0">
                              {{ desktopCategoryCounts.get(category.id) }}
                            </span>
                          </a>

                          <div *ngIf="category.children?.length" class="desktop-subcategory-grid">
                            <button *ngFor="let subcategory of category.children; trackBy: trackByChild" type="button"
                              (click)="onSubcategoryClick(subcategory)" class="desktop-subcategory-link">
                              {{ (subcategory.label || subcategory.name) | translate }}
                              <span *ngIf="subcategory.products_count !== undefined || subcategory.additional_products_count !== undefined">
                                ({{ (subcategory.products_count || 0) + (subcategory.additional_products_count || 0) }})
                              </span>
                            </button>
                          </div>
                        </article>
                      </div>
                      <p *ngIf="section.categories.length === 0" class="desktop-empty-section">
                        {{ isPromoMenuSelection
                          ? (menuSelection === 'SALE'
                            ? ('mega_menu.no_sale' | translate:'Obecnie brak produktów w promocji.')
                            : ('mega_menu.no_new' | translate:'Obecnie brak nowych produktów.'))
                          : ('mega_menu.no_categories' | translate:'Brak dostępnych kategorii.') }}
                      </p>
                    </section>
                  </ng-container>
                  <p *ngIf="desktopSections.length === 0" class="desktop-empty-section">
                    {{ 'mega_menu.no_sections' | translate:'Brak dostępnych sekcji.' }}
                  </p>
                </div>

                <aside *ngIf="!isPromoMenuSelection" class="desktop-product-help">
                  <div>
                    <h3>{{ 'mega_menu.help_title' | translate:'Nie możesz znaleźć odpowiedniego produktu?' }}</h3>
                    <p>{{ 'mega_menu.help_body' | translate:'Prześlij parametry techniczne, numer katalogowy lub zdjęcie tabliczki znamionowej.' }}</p>
                  </div>
                  <a routerLink="/info/contact" (click)="onLinkClick()" class="desktop-product-help-link">
                    {{ 'mega_menu.help_action' | translate:'Poproś o pomoc w doborze produktu' }}
                    <span aria-hidden="true">→</span>
                  </a>
                </aside>
              </div>
            </div>
            <app-product-preview-popup *ngIf="showNewProductPreview" [product]="selectedNewProduct"
              [showModal]="showNewProductPreview" (closeModalEmitter)="closeNewProductPreview()">
            </app-product-preview-popup>

            <!-- Right side: Images -->
          <div *ngIf="false"
            class="desktop-legacy-images hidden xl:flex flex-col gap-8 items-center justify-start xl:pt-4 w-64 flex-shrink-0 pl-8">
            <!-- SALE Tab Special Display -->
            <div *ngIf="hoveredCategory?.name === 'SALE'" class="flex flex-col gap-4">
              <!-- SAVE % Section -->
              <div
                class="w-48 md:w-56 xl:w-64 h-32 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex flex-col items-center justify-center text-white shadow-md">
                <div class="text-3xl md:text-4xl font-black mb-1">{{ 'OSZCZĘDŹ' | translate }}</div>
                <div class="text-sm md:text-base font-bold tracking-widest">{{ 'NAJLEPSZE OFERTY' | translate }}</div>
              </div>

              <!-- ORDER ONLINE Section -->
              <div
                class="w-48 md:w-56 xl:w-64 h-32 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex flex-col items-center justify-center text-white cursor-pointer shadow-md"
                routerLink="/products" [queryParams]="{ discount: true }" (click)="onLinkClick()">
                <div class="text-xl md:text-2xl font-black mb-1">{{ 'ZAMÓW ONLINE' | translate }}</div>
                <div class="text-sm font-bold tracking-widest">{{ 'KUP TERAZ' | translate }}</div>
              </div>
            </div>

            <!-- Regular Images for other tabs -->
            <ng-container *ngIf="hoveredCategory?.name !== 'SALE'">


              <!-- Second image (slider) -->
              <div class="relative w-48 md:w-56 xl:w-64 h-auto flex-shrink-0 group shadow-sm rounded-lg"
                *ngIf="sliderImages.length > 0" (mouseenter)="pauseSlideshow()" (mouseleave)="resumeSlideshow()"
                (touchstart)="handleTouchStart($event)" (touchend)="handleTouchEnd($event)">
                <div class="overflow-hidden rounded-lg">
                  <div class="flex transition-transform duration-500 ease-in-out"
                    [style.transform]="'translateX(-' + (currentSlideIndex * 100) + '%)'">
                    <app-optimized-image *ngFor="let imageUrl of sliderImages; trackBy: trackByImage; let i = index"
                      [src]="imageUrl"
                      [alt]="(apiSliderImages[i] && apiSliderImages[i].altText) || 'Navigation gallery image ' + (i + 1)"
                      [width]="320" [height]="240" aspectRatio="4/3" loading="lazy" fetchpriority="low"
                      cssClass="cursor-pointer flex-shrink-0" containerClass="w-48 md:w-56 xl:w-64 h-auto bg-white"
                      [showSkeleton]="true" routerLink="/products" (click)="onLinkClick()"></app-optimized-image>
                  </div>
                </div>

                <!-- Slider Navigation Controls -->
                <ng-container *ngIf="sliderImages.length > 1">
                  <!-- Navigation dots -->
                  <div
                    class="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-1.5 z-10 px-2 py-1 rounded-full bg-black/10 backdrop-blur-[2px]">
                    <button *ngFor="let slide of sliderImages; index as i" type="button"
                      (click)="goToSlide(i); $event.stopPropagation()"
                      class="w-1.5 h-1.5 rounded-full transition-all duration-300"
                      [class.bg-orange-500]="i === currentSlideIndex" [class.bg-white]="i !== currentSlideIndex"
                      [class.w-4]="i === currentSlideIndex" [attr.aria-label]="'Przejdź do slajdu ' + (i + 1)"></button>
                  </div>

                  <!-- Navigation arrows -->
                  <button (click)="previousSlide(); $event.stopPropagation()"
                    class="absolute left-1.5 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-sm transition-all duration-200 hover:scale-110 opacity-0 group-hover:opacity-100 z-10"
                    [attr.aria-label]="'Poprzednie zdjęcie' | translate">
                    <svg class="w-3.5 h-3.5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>

                  <button (click)="nextSlide(); $event.stopPropagation()"
                    class="absolute right-1.5 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-sm transition-all duration-200 hover:scale-110 opacity-0 group-hover:opacity-100 z-10"
                    [attr.aria-label]="'Następne zdjęcie' | translate">
                    <svg class="w-3.5 h-3.5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </ng-container>
              </div>

              <!-- First image (static) -->
              <div class="flex-shrink-0">
                <app-optimized-image *ngIf="firstImage" [src]="firstImage?.imageUrl || ''"
                  [alt]="firstImage?.altText || 'Obraz nawigacyjny polecanych produktów'" [width]="320" [height]="240"
                  aspectRatio="4/3" loading="lazy" fetchpriority="low" cssClass="cursor-pointer rounded-lg shadow-sm"
                  containerClass="w-48 md:w-56 xl:w-64 h-auto bg-white" [showSkeleton]="true" routerLink="/products"
                  (click)="onLinkClick()"></app-optimized-image>
                <!-- Fallback placeholder when no firstImage -->
                <div *ngIf="!firstImage"
                  class="w-48 md:w-56 xl:w-64 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg cursor-pointer flex items-center justify-center shadow-inner"
                  style="aspect-ratio: 4/3;" routerLink="/products" (click)="onLinkClick()">
                  <div class="text-center">
                    <svg class="w-8 h-8 mx-auto text-gray-400 mb-2" fill="none" stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                      </path>
                    </svg>
                    <p class="text-xs text-gray-500">{{ 'Polecane produkty' | translate }}</p>
                  </div>
                </div>
              </div>

              <!-- Fallback gallery placeholder when no slider images -->
              <div *ngIf="sliderImages.length === 0"
                class="relative w-48 md:w-56 xl:w-64 bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg cursor-pointer flex items-center justify-center"
                style="aspect-ratio: 4/3;" routerLink="/products" (click)="onLinkClick()">
                <div class="text-center">
                  <svg class="w-8 h-8 mx-auto text-purple-400 mb-2" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
                    </path>
                  </svg>
                  <p class="text-xs text-purple-500">{{ 'Galeria' | translate }}</p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>